module.exports = __webpack_public_path__ + "69eaaed39d893b30ea51b51411d58d12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/svg-set/index-regular-workshop.svg
// module id = 1105
// module chunks = 0